if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

/* js code for arrows and dots*/
document.addEventListener('DOMContentLoaded', () => {
  const mediaGallery = document.querySelector('media-gallery');
  if (!mediaGallery) return;

  const dots = mediaGallery.querySelectorAll('.dot');
  const slides = mediaGallery.querySelectorAll('.product__media-item');
  const thumbnails = mediaGallery.querySelectorAll('.thumbnail');
  const prevButton = mediaGallery.querySelector('.slider-button--prev');
  const nextButton = mediaGallery.querySelector('.slider-button--next');
  const videoButton = document.querySelector('.product__video-button'); // Button to view the video
  const slider = mediaGallery.querySelector('.slider'); // Assuming your slider has a class `slider`

  let currentIndex = 0;
  let isThrottled = false;

  // Function to update slider view
  const updateSlider = (index) => {
    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    dots.forEach((dot, i) => {
      dot.classList.toggle('active', i === index);
    });
    thumbnails.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
    });
  };

  // Function for looping slider
  const loopSlider = (index) => {
    if (index < 0) {
      currentIndex = 0; // Prevent going to the last dot when swiping left on the first
    } else if (index >= slides.length) {
      currentIndex = slides.length - 1; // Prevent going to the first dot when swiping right on the last
    } else {
      currentIndex = index;
    }
    updateSlider(currentIndex);
  };

  // Event listener for dots
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentIndex = index; // Directly set index on dot click
      updateSlider(currentIndex);
    });
  });

  // Event listener for thumbnails
  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      currentIndex = index; // Directly set index on thumbnail click
      updateSlider(currentIndex);
    });
  });

  // Event listeners for arrows
  const handleArrowClick = (increment) => {
    if (isThrottled) return; // Prevent rapid clicks
    isThrottled = true;

    loopSlider(currentIndex + increment);

    setTimeout(() => {
      isThrottled = false;
    }, 200); // Adjusted timeout for faster interaction
  };

  prevButton.addEventListener('click', () => handleArrowClick(-1));
  nextButton.addEventListener('click', () => handleArrowClick(1));

  // Event listener for the video button
  if (videoButton) {
    videoButton.addEventListener('click', () => {
      currentIndex = slides.length - 1; // Assume the video is the last slide
      updateSlider(currentIndex);
    });
  }

  // Add swipe listener for touch interaction
  let startX = 0;

  slider.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  slider.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;

    if (Math.abs(diffX) > 30) { // Swipe threshold
      if (diffX > 0) {
        // Swipe left
        currentIndex = Math.min(currentIndex + 1, slides.length - 1); // Prevent looping back to last dot
      } else {
        // Swipe right
        currentIndex = Math.max(currentIndex - 1, 0); // Prevent looping back to first dot
      }
      updateSlider(currentIndex);
    }
  });

  // Update dots when scrolling (if slider uses scroll for navigation)
  slider.addEventListener('scroll', () => {
    const slideWidth = slides[0].offsetWidth;
    const scrollLeft = slider.scrollLeft;
    const index = Math.round(scrollLeft / slideWidth);

    if (index !== currentIndex) {
      currentIndex = index;
      updateSlider(currentIndex);
    }
  });

  // Initialize the slider
  updateSlider(currentIndex);
});

